// extracted by css-extract-rspack-plugin
export default {"field":"field-P80TJA","sectionHeader":"sectionHeader-fWIwSW","sectionHeaderLabel":"sectionHeaderLabel-zFIM4T","sectionHeaderLine":"sectionHeaderLine-yavVoA"};